import { render, staticRenderFns } from "./AccesControlStatic.vue?vue&type=template&id=17d80b30"
import script from "./AccesControlStatic.vue?vue&type=script&lang=js"
export * from "./AccesControlStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports